import React from 'react';

type IconProps = {
  size?: number; // Size of the icon
  className?: string; // Additional custom classes
};

const MakeupIcon: React.FC<IconProps> = ({ size = 22, className = '' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.97413 9.64845L11.8922 12.5665C12.6109 13.2852 12.6109 14.4506 11.8922 15.1694L9.07399 17.9875C7.99602 19.0655 6.24829 19.0655 5.17032 17.9875L3.55373 16.3709C2.47576 15.293 2.47576 13.5452 3.55373 12.4673L6.3719 9.6491C7.09066 8.93033 8.25602 8.93033 8.97478 9.6491L8.97413 9.64845Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9609 7.31754L14.5374 3.74105C15.0296 3.24935 15.7572 3.07756 16.4174 3.2972L18.6238 4.03084C18.9279 4.12998 19.1584 4.38042 19.232 4.6917C19.3056 5.00299 19.2117 5.33013 18.9842 5.55498L14.1339 10.4043"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.63477 9.11403L9.13231 7.6174C9.43179 7.31747 9.83825 7.14893 10.2621 7.14893C10.686 7.14893 11.0924 7.31747 11.3919 7.6174L13.9248 10.1503C14.2247 10.4498 14.3933 10.8562 14.3933 11.2801C14.3933 11.704 14.2247 12.1104 13.9248 12.4099L12.4282 13.9074"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MakeupIcon;
